(function ($, window, undefined) {
    'use strict';

    $('.group-bt a').on('click', function () {
        $('.group-bt a').toggleClass('active');

        if ($(this).hasClass('mensal')) {
            $('#planos-box .plan-box.plan-premium .apartir-de').html('a partir de');
            $('#planos-box .plan-box.plan-premium .price').html('<small>R$</small> 57,<span class="cents">00</span>');
            $('#planos-box .plan-box.plan-sociedade .apartir-de').html('a partir de');
            $('#planos-box .plan-box.plan-sociedade .price').html('<small>R$</small> 87,<span class="cents">00</span>');
          
        } else {
            $('#planos-box .plan-box.plan-premium .apartir-de').html('a partir de');
            //$('#planos-box .plan-box.plan-premium .price').html('<small>R$</small> 39,<span class="cents">90</span><span class="parcelamentoPremiumAnual">Em 4X de R$179</span>');
            $('#planos-box .plan-box.plan-premium .price').html('<small>R$</small> 47,<span class="cents">00</span>');
            $('#planos-box .plan-box.plan-sociedade .apartir-de').html('a partir de');
            //$('#planos-box .plan-box.plan-sociedade .price').html('<small>R$</small> 129,<span class="cents">90</span> <span class="parcelamentoPremiumAnual">Em 4X de R$389,90</span>');
            $('#planos-box .plan-box.plan-sociedade .price').html('<small>R$</small> 77,<span class="cents">00</span>');
       
        }

        return false;
    });

	/*
	 * Bloqueia o scroll quando o menu estiver aberto
	 */
	$(document).on('touchmove mousewheel DOMMouseScroll', '.popup-full, .overlay-mask', function (e) {
		e.preventDefault();
	});

}(jQuery, window));